<template>
  <div class="fast-reply" @click="cancelHide">
    <van-tabs v-model="activeTab" class="activeTab" @change="changeTab">
      <van-tab title="话术" name="left_produre"></van-tab>
      <!-- <van-tab title="物料" name="material"></van-tab> -->
      <van-tab title="雷达" name="inter"></van-tab>
      <van-tab title="个人" name="right_produre"></van-tab>
    </van-tabs>
    <dl class="speareLine"></dl>
    <div class="reply_wrap">
      <div v-if="activeTab !== 'inter' && activeTab !== 'material'" class="flex-center mar-bott special_padding">
        <van-search class="flex1" v-model="titleval" @clear="search" placeholder="搜索话术名称" />
        <span @click="search" class="search-text" :style="{ color: titleval ? '#277FFF' : '' }">搜索</span>
      </div>

      <div class="tree-content" v-if="activeTab === 'left_produre'">
        <van-list v-model="loading" :finished="finished" loading-text="加载中..." :finished-text="finishedtext" @load="load_more" :immediate-check="false">
          <tree-child ref="child" :datalist="childlist" v-model="selectVal" :titleval="titleval"></tree-child>
        </van-list>
      </div>
      <div class="tree-content" v-if="activeTab === 'right_produre'">
        <van-list v-model="loading" :finished="finished" loading-text="加载中..." :finished-text="finishedtext" @load="load_more" :immediate-check="false">
          <personal-tree ref="personalTree" @personalList="search" :datalist="childlist" :titleval="titleval"></personal-tree>
        </van-list>
      </div>
      <div class="tree-content" v-if="activeTab === 'inter'">
        <!-- <inter-tab ref="interinfo" :wechatUserId="wechatUserId"></inter-tab> -->
        <intergroup-list ref="interinfo"></intergroup-list>
      </div>
      <div class="tree-content" v-if="activeTab === 'material'">
        <material-library ref="material"></material-library>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import treeChild from "@/components/treeChild.vue";
import personalTree from "@/components/personalTree.vue";
// import interTab from "./interTab.vue";
import intergroupList from "./intergroupList.vue";
import materialLibrary from "../materialLibrary/materialLibrary.vue";
import { grouplist } from "@/server/api.js";
import { wefunstatistics, addressBar } from "@/utils/public";
import { wxConfig } from "@/views/fastReply/js/config";
export default {
  components: { treeChild, personalTree, intergroupList, materialLibrary },
  data() {
    return {
      pageNum: 1,
      pageSize: 30,
      titleval: "",
      loading: false,
      finished: false,
      selectVal: {},
      childlist: [],
      error: false,
      activeTab: "left_produre",
      finishedtext: "没有更多了",
      type: 0,
      jsList: ["sendChatMessage", "getCurExternalContact"],

      show: false,
      showPickerType: false,
      option: [],
      wechatUserId: "",
    };
  },
  created() {
    let activeTab = this.$route.query.activeTab;
    if (activeTab) {
      this.activeTab = activeTab;
      this.type = 1;
    }
  },
  async mounted() {
    let windowurl = window.location.href.split("#")[0] || "https://xyqw.xinyuanhulian.com/reply";
    if (localStorage.getItem("token")) {
      // let res = await this.replyConfig();
      // console.log(res);
      wxConfig(windowurl, this.jsList).then(async () => {
        let res = await this.getWechatId();
        // == "material"
        if (localStorage.getItem("replytab")) {
          this.activeTab = localStorage.getItem("replytab");
          this.changeTab(localStorage.getItem("replytab"));
          localStorage.removeItem("replytab");
        } else {
          await this.grouplist();
          // this.changeTab("inter");
          wefunstatistics("1", window.location.href.split("#")[0]);
        }
      });
    } else {
      addressBar("token", windowurl);
    }
  },
  methods: {
    //默认话术
    async grouplist(scroll) {
      this.loading = true;
      let params = {
        title: this.titleval,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        type: this.type,
      };
      let res = await grouplist(params);
      this.loading = false;
      if (res.code !== "200") {
        Toast.fail(res.msg);
        this.finished = true;
        this.finishedtext = res.msg;
        return;
      }
      this.childlist = this.childlist.concat(res.data.t);
      //console.log(this.childlist);
      // this.total = res.data.tolNum;
      if (res.data.t.length == 0 || res.data.t.length < this.pageSize) {
        this.finishedtext = this.childlist.length ? "没有更多了" : "暂无话术";
        //数据全部加载完成
        this.finished = true;
        if (scroll) {
          this.$nextTick(() => {
            window.scrollTo(0, scroll);
          });
        }
      } else {
        this.finished = false;
      }
    },

    load_more() {
      this.pageNum++;
      this.grouplist();
    },

    changeTab(val) {
      this.childlist = [];
      this.pageNum = 1;
      this.titleval = "";
      if (val === "right_produre") {
        this.type = 1;
        this.grouplist();
      } else if (val === "left_produre") {
        this.type = 0;
        this.grouplist();
      } else if (val === "inter") {
        this.$nextTick(() => {
          this.$refs.interinfo.interGroup();
        });
      } else if (val === "material") {
        this.$nextTick(() => {
          this.$refs.material.getFileList();
          this.$refs.material.getLabelList();
          this.$refs.material.getTypeList();
          this.$refs.material.getList();
        });
      }
    },
    search(scroll) {
      this.childlist = [];
      this.pageNum = 1;
      this.grouplist(scroll);
      this.$refs.personalTree.activeItem();
      this.$refs.child.activeItem();
    },
    cancelHide() {
      if (this.activeTab === "right_produre") {
        this.$nextTick(() => {
          this.$refs.personalTree.cancelHide();
        });
      }
    },
    replyConfig() {
      wxConfig(window.location.href.split("#")[0], ["sendChatMessage", "getCurExternalContact"]);
    },
    getWechatId() {
      let that = this;
      wx.invoke("getCurExternalContact", {}, function (res) {
        if (res.userId) {
          that.wechatUserId = res.userId;
          // that.interSearch();
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
@import "css/fastReply";
</style>
